import { render, staticRenderFns } from "./BardButtonsSettingFieldtype.vue?vue&type=template&id=508fcc3b&"
import script from "./BardButtonsSettingFieldtype.vue?vue&type=script&lang=js&"
export * from "./BardButtonsSettingFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports